<template>
    <div id="footer">
        
        <hr class="solid">

        <div class="row helpSection">
            <div class="col-md-3 col-sm-12">
                <strong class="helpWord">Need Help?</strong>
            </div>

            <div class="col-md-6 contactGroup">
                <div class="contactMethod">
                    <div><i class="bi bi-telephone-fill contactIcon"></i></div>
                    <a class="twolinetext" href="tel:604-637-5000">
                        <div class="footergroup-header"><strong>Call us</strong></div>
                        <div class="footergroup-text">604-637-5000</div>
                    </a>
                </div>

                <div class="contactMethod">
                    <div><i class="bi bi-envelope-fill contactIcon"></i></div>
                    <a class="twolinetext" href="mailto:info@comsavings.com">
                        <div class="footergroup-header"><strong>Email us</strong></div>
                        <div class="footergroup-text">info@comsavings.com</div>
                    </a>
                </div>
            </div>


            <div class="col-md-3 socialMedia">
                <div class="">
                    Find us on social media
                </div>

                <div>
                    <div class="socialmedialink">
                        <a href="https://www.facebook.com/CommunitySavings/" title="facebook"><span style="display: none;">facebook</span>
                            <i class="bi bi-facebook"></i>
                        </a>
                    </div>
                    <div class="socialmedialink">
                        <a href="https://twitter.com/ComSavings" title="twitter"><span style="display: none;">twitter</span>
                            <i class="bi bi-twitter-x"></i>
                        </a>
                    </div>
                    <div class="socialmedialink">
                        <a href="https://www.instagram.com/comsavings/?hl=en" title="instagram"><span style="display: none;">instagram</span>
                            <i class="bi bi-instagram"></i>
                        </a>
                    </div>
                    <div class="socialmedialink">
                        <a href="https://www.linkedin.com/company/community-savings-credit-union-bc/?originalSubdomain=ca" title="linkedin"><span style="display: none;">linkedin</span>
                            <i class="bi bi-linkedin"></i>
                        </a>
                    </div>
                </div>
            </div>

        </div>

        <small id="copyright">
            © 2026 Community Savings Credit Union. All rights reserved.
        </small>
    </div>
</template>

<style>
    #footer {
        width: 100%;
        height: 200%;
        padding: 2% 75px;
        
        a {
            color: black !important;
        }
    }

    .form-check-label {
        a {
            color: #0061a9;
        }
    }

    .helpSection {
        padding: 1em;
    }

    .helpWord {
        font-size: 1.8em;
    }

    .contactGroup {
        display: flex;
        justify-content: space-around;
    }

    .contactMethod {
        display: inline-flex;
    }

    .contactIcon {
        padding-right: .5em;
    }

    .twolinetext {
        display: inline-block;
    }

    .socialMedia {
        text-align: center;
    }

    .socialmedialink {
        display: inline-block;
        padding-right: .8em;
    }

    .bi {
        color: #0061a9;
    }

    @media only screen and (max-width: 600px) {
        
        #info {
            margin: 0 5% 0 5%;
            display:inline-block;
            
        }

        .contactGroup {
            display: block;
        }

        .contactMethod {
            padding-top: 10%;
        }

        .socialMedia {
            padding-top: 10%;
        }
    }
</style>